/* eslint-disable import/no-extraneous-dependencies */
import React, { Suspense } from 'react'
import { ApolloProvider } from '@apollo/client'

import ModalsProvider from 'providers/ModalsProvider'
import useDetectMobile from 'hooks/useDetectMobile'
import useApollo from 'hooks/useApollo'
import Routes from './Routes'
import { BrowserRouter as Router } from 'react-router-dom'
import ScrollToTop from 'helpers/ScrollToTop'
import { SnackbarProvider } from 'notistack'
import './i18n'
import 'iframe-resizer/js/iframeResizer.contentWindow'

const App = () => {
  useDetectMobile()
  const client = useApollo()

  return (
    <ModalsProvider>
      <ApolloProvider client={client}>
        <SnackbarProvider>
          <Router>
            <Suspense fallback={'Loading...'}>
              <ScrollToTop />
              <Routes />
            </Suspense>
          </Router>
        </SnackbarProvider>
      </ApolloProvider>
    </ModalsProvider>
  )
}

export default App
